import sizes from 'modules/application-link/domain/constants/sizes';
import useMediaQuery from 'shared/hooks/use-media-query';
import UDLogo from 'ud-ui/components/logo';
import S from '../pages/styles';
import Background from './backgound';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const isMobile = useMediaQuery(`(max-width: ${sizes.mobile.WIDTH}px)`);

  return (
    <S.Container>
      <S.FormContainer
        style={{
          padding: isMobile ? '0 16px' : '0',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: isMobile ? '100vh' : 'auto',
        }}
      >
        <div>
          <UDLogo id="logo" fontSize={isMobile ? 28 : 24} />
        </div>
        {children}
      </S.FormContainer>
      <Background />
    </S.Container>
  );
};

export default Layout;
